<template>
    <footer class="pt-5">
        <div class="container">
            <div class="copyright">
                <img src="../assets/logo.svg" width="150" alt="">
                <p>
                    &copy; Copyright {{year}} empowerdirect.com
                </p>
            </div>
        </div>
    </footer>
</template>

<script>
    import { format } from 'date-fns';

    export default {
        name: 'Footer',

        data() {
            return {
                year: format(new Date(), 'Y'),
            };
        },
    };
</script>

<style lang="scss">
    @import '../scss/variables';

    footer {
        .copyright {
            text-align: center;
            color: #6f6d77;
            @include font-size(14px);
            position: relative;
            p {
                padding: 10px;
            }
        }
    }
</style>
